
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { Dossier } from '../dossier/dossier';
import { DossierService, DossierFilter } from '../dossier/dossier.service';
import { DossierFilterDialogComponent } from '../dossier/dossier-filter-dialog.component';
import { NotifierService, DialogService } from '../ui';

import { find } from 'lodash';

@Component({
  selector: 't-select-dossier',
  templateUrl: './select-dossier.component.html',
})
export class SelectDossierComponent implements OnInit, OnChanges {
  
  filter: DossierFilter;

  perPage = 10
  dossiersCount: number = 0
  dossiers: Dossier[]

  @Input() selectedDossier: Dossier
  @Output() selectedDossierChange = new EventEmitter();

  @Input() showFilter: boolean
  @Output() showFilterChange = new EventEmitter();

  constructor(
    private dossierService: DossierService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new DossierFilter();
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.dossiers.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.dossierService
      .dossiers(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.dossiers = result.dossiers;
        }
        // Append
        else {
          this.dossiers = [...this.dossiers || [], ...result.dossiers];
        }

        // Check that the selected dossier is in the selection
        if(this.selectedDossier) {
          if(!find(this.dossiers, d => d.id === this.selectedDossier.id)) {
            this.onSelect(null);
          }
        }

        this.dossiersCount = result.dossiersCount;
      });
  }

  onSelect(dossier: Dossier) {
    this.selectedDossier = dossier;
    this.selectedDossierChange.emit(dossier);

    return false;
  }

  applyFilter() {
    this.dialogService.show({
      component: DossierFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
          this.showFilter = false;
          this.showFilterChange.emit(false);
        },

        onApply: (filter: DossierFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['showFilter']) {
      if(this.showFilter) {
        this.applyFilter();
      }
    }
  }
}
